import { Link } from 'react-router-dom';
import LoginBrand from './LoginBrand';
import './SidebarBrand.css';

/**
 * Marke oben links in der Seitenleiste (Welle 0, logo-dashboard). Zeigt das originale CLAiRIS-Logo der
 * Anmeldeseite: offen die Wortmarke, eingeklappt das CL-Monogramm. Beides kommt unverändert aus
 * LoginBrand.tsx (dieselben Vorlagen, dieselbe Zweifarb-Maske); die Farben liefern die --cl-brand-*-Tokens
 * für hell und dunkel. CLAiRIS ist eine eigene SaaS-Lösung: Logo oder Name einer Organisation erscheinen
 * hier nie (Benny, 24.09.2026).
 */
export default function SidebarBrand({ collapsed = false }: { collapsed?: boolean }) {
  return (
    <Link to="/" className={`sidebar-brand${collapsed ? ' sidebar-brand-collapsed' : ''}`} aria-label="CLAiRIS Startseite">
      <LoginBrand monogram={collapsed} />
    </Link>
  );
}
